import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { useRegisterSW } from "virtual:pwa-register/react";
import { useTranslation } from "@/shared/hooks/useTranslation";

const OFFLINE_READY_DURATION = 3000;

/**
 * Registers the service worker and surfaces the "ready offline" notice once.
 * Updates are silent (registerType: 'autoUpdate'): a new SW activates, claims
 * clients and reloads the page on its own, so there is no update prompt.
 */
export const PwaOfflineReadyToast = (): null => {
  const {
    offlineReady: [offlineReady],
  } = useRegisterSW();
  const { t } = useTranslation();

  const fired = useRef(false);

  useEffect(() => {
    if (!offlineReady) {
      fired.current = false;
      return;
    }
    if (fired.current) return;
    fired.current = true;

    toast(t("pwa.offlineReady"), { duration: OFFLINE_READY_DURATION });
  }, [offlineReady, t]);

  return null;
};
